<template>
  <div id="app">
    <Crusarder />
    <Drone />
    <main>
      <BlackBoxLoader :num="1">
        <router-view :key="$route.fullPath"></router-view>
      </BlackBoxLoader>
    </main>
  </div>
</template>

<script>
import BlackBoxLoader from "@/components/BlackBoxLoader";
import Drone from "@/components/Drone";
import Crusarder from "@/components/Crusarder";
export default {
  name: "AffakKhan",
  components: {
    BlackBoxLoader,
    Crusarder,
    Drone
  }
};
</script>

<style lang="scss">
@font-face {
  font-family: "primaryFont";
  src: url("./styles/fonts/SairaCondensed-Regular.ttf");
}

body {
  background: $darkPrimary;
  color: $lightPrimary;
  font-family: "primaryFont", san-serif;
  text-align: center;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
